import ymaps from 'ymaps';

import getBalloonLayout from '@/js/helpers/getBalloonLayout';
import getBalloonContentLayout from '@/js/helpers/getBalloonContentLayout';
import getDescription from '@/js/helpers/getDescription';

export default class Map {
  constructor($c) {
    this.$c = $c;
    this.points = $c.data('points');

    this.createMap();
    this.addPlacemarks();
    this.updateCenter();
  }
  // создание и настройка карты
  createMap() {
    const zoomControl = new ymaps.control.ZoomControl({
      options: {
        position: {
          left: 'auto',
          right: 20,
          top: 170
        }
      }
    });

    this.map = new ymaps.Map(this.$c[0], {
      center: [0, 0],
      zoom: 7,
      controls: [zoomControl]
    });

    this.$c[0]._kriosMap = this.map;
    this.map.behaviors.disable('scrollZoom');
    this.map.events.add('click', () => this.map.balloon.close());
  }
  // добавление меток на карту
  addPlacemarks() {
    this.points.forEach((point) => {
      const description = getDescription({
        title: point.title,
        text: point.text,
        link: point.link
      });
      const placemark = this.getPlacemark(point.coords, description);

      this.map.geoObjects.add(placemark);
    });
  }
  // обновление центра карты в зависимости от точек
  updateCenter() {
    const { map } = this;
    const { geoObjects } = map;

    map.setBounds(geoObjects.getBounds(), {
      checkZoomRange: true
    }).then(() => map.setZoom(map.getZoom() - 2)).then(() => {
      const { balloon } = geoObjects.get(0);
      return balloon.open();
    });
  }
  // создание метки
  getPlacemark(coords, content) {
    const placemark = new ymaps.Placemark(coords, { content }, {
      balloonLayout: getBalloonLayout(),
      balloonContentLayout: getBalloonContentLayout(),
      balloonPanelMaxMapArea: 0,
      iconLayout: 'default#image',
      iconImageHref: this.$c.data('placemark-url'),
      iconImageSize: [95, 104],
      iconImageOffset: [-48, -60]
    });

    return placemark;
  }
}
